export default __webpack_public_path__ + "static/media/toast-stop-presenter.349de8c6.svg";